import { useQueries } from '@tanstack/react-query';
import { fetchPurchaseOrder } from '../../../../services/purchaseOrders';
import { BILLING_PURCHASE_ORDER_KEY } from '../../../../hooks/queryKeys';
import type { PurchaseOrderItem } from '../../../../services/billing';

// A charge carries only a handful of POs, so resolving each through the same
// GET /:id the drawer already caches is cheap enough to pre-exclude ordered lines.
export function useLiveOrderedLineItemIds(purchaseOrders: readonly PurchaseOrderItem[]): {
    liveLineItemIds: Set<string>;
    isLoading: boolean;
} {
    // A PO that never actually dispatched (error set) has no real lines to check.
    const candidates = purchaseOrders.filter((po) => po.error === null);

    const results = useQueries({
        queries: candidates.map((po) => ({
            queryKey: BILLING_PURCHASE_ORDER_KEY(po.id),
            queryFn: () => fetchPurchaseOrder(po.id),
            staleTime: 60 * 1000
        }))
    });

    const liveLineItemIds = new Set<string>();
    for (const result of results) {
        for (const line of result.data?.lines ?? []) {
            if (line.canceledAt === null) liveLineItemIds.add(line.chargeLineItemId);
        }
    }

    return { liveLineItemIds, isLoading: results.some((result) => result.isLoading) };
}
